import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'tt-business-co-default-counter',
  templateUrl: './business-co-default-counter.component.html',
  styleUrls: ['./business-co-default-counter.component.css']
})
export class BusinessCoDefaultCounterComponent implements OnInit {
    defaultCounterKeyno;

    businessCoNo;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.defaultCounterKeyno = this.stateService.getStateParams()['defaultcounter_keyno'];
        this.businessCoNo = this.stateService.getStateParams()['businessco_no'];
    }

    private async loadEdit() {
        if (!!this.defaultCounterKeyno && !!this.businessCoNo) {
            this.edit = (await this.datatask.Post(3911, {
                defaultcounter_keyno: this.defaultCounterKeyno,
                businessco_no: this.businessCoNo
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3912, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    defaultcounter_keyno: string;
    counter_id: string;
    counter_information: string;
    defaultcounter_description: string;
    lastnumber_in_this_database: string;
    counter_nextnumber: string;
}
